import { render, staticRenderFns } from "./xs_activity.vue?vue&type=template&id=5d13f2d4&"
import script from "./xs_activity.vue?vue&type=script&lang=js&"
export * from "./xs_activity.vue?vue&type=script&lang=js&"
import style0 from "./xs_activity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports